export const PSD_PARSE_CHANNEL_PREFIX = 'psd-parse.';

export const PSD_PARSE_EVENTS = {
  STATUS_UPDATE: '.status-update',
  PROGRESS_UPDATE: '.progress-update'
}
